import { z } from 'zod';

export function useAspirationFormSchema() {
  return z.object({
    leftLarge: z.number().int(),
    leftMedium: z.number().int(),
    leftSmall: z.number().int(),
    rightLarge: z.number().int(),
    rightMedium: z.number().int(),
    rightSmall: z.number().int(),
    leftTotal: z.number().int(),
    rightTotal: z.number().int(),
    comments: z.string().nullable(),
    leftCls: z.number().int(),
    leftCysts: z.number().int(),
    rightCls: z.number().int(),
    rightCysts: z.number().int(),
    didNotAspirate: z.boolean(),
    donorCondition: z.string().optional().nullable(),
    donorConditionChanged: z.boolean().optional(),
    pregnant: z.boolean(),
    weight: z.string(),
    weightIn: z.string(),
    nextScheduleId: z.string(),
    cdComments: z.string().optional(),
    opuTime: z.string().min(1, { message: 'OPU Time is required' }),
    bodyConditionScore: z.number().nullish(),
    donorCategory: z.number().nullish(),
  });
}

export type AspirationFormValues = z.infer<
  ReturnType<typeof useAspirationFormSchema>
>;
